<template>
	<v-modal :name="this.modalId" header="Médiatár" :maxWidth="'90%'" :passed-data="(passedData: object) => onModalPassedData(passedData)">
        <template #body>
			<div class="media-library">
				
				<button class="button-unit mb-3" v-if="selectedFolders.length > 0" @click="backFolder">Vissza</button>
				
				<div class="media-boxes">
					<div v-for="folder in folders" class="media-box media-box--folder">
						<div class="media-box__image">
							<i class="fa-solid fa-folder"></i>
						</div>
						<div class="media-box__title">
							{{ folder.name }}
						</div>
						<div class="media-box__folder">
							<i class="fa-regular fa-clock"></i> {{ new Date(folder.created_at).toLocaleDateString() }}
						</div>
						<ul class="media-box__details">
							<li><i class="fa-solid fa-images"></i> {{ folder.images_count }} db</li>
						</ul>
						<a href="#" class="stretched-link" @click.prevent="openFolder(folder.id)"></a>
					</div>
					
					<div v-for="image in images" class="media-box">
						<div class="media-box__image">
							<template v-if="['jpg','jpeg','png','gif'].includes(image.extension)">
								<img :src="image.original" />
							</template>
							<template v-else-if="['mp4','avi','mpeg','webm'].includes(image.extension)">
								<i class="fa-solid fa-video"></i>
							</template>
							<template v-else>
								<i class="fa-solid fa-file"></i>
							</template>
						</div>
						<div class="media-box__title">
							{{ image.name }}
						</div>
						<div class="media-box__folder">
							<i class="fa-solid fa-folder"></i> {{ image.folder }}
						</div>
						<ul class="media-box__details">
							<li><i class="fa-solid fa-image"></i> {{ image.extension }}</li>
							<li>{{ image.width }}x{{ image.height }}</li>
							<li>{{ image.size }}</li>
						</ul>
						<a href="#" class="stretched-link" @click.prevent="selectImage(image)"></a>
					</div>
				</div>
			</div>
		</template>
	</v-modal>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import VModal from "@AdminComponents/VModal.vue";
import axios from "axios";
import {MediaLibraryModalFolderInterface} from "@AdminComponents/Modals/MediaLibraryModal/Interfaces/MediaLibraryModalFolderInterface";
import {MediaLibraryModalImageInterface} from "@AdminComponents/Modals/MediaLibraryModal/Interfaces/MediaLibraryModalImageInterface";

export default defineComponent({
	name: 'MediaLibraryModal',
	inject: ['emitter'],
	components: {VModal},
	data() {
		return {
			modalId: 'media-library',
			folders: [] as MediaLibraryModalFolderInterface[],
			images: [] as MediaLibraryModalImageInterface[],
			selectedFolders: [] as string[],
			passedData: {} as {imageUploadId: string},
		}
	},
	mounted() {
		this.emitter.on('onModalShow_' + this.modalId, async () => {
			await this.fetchFolders();
			await this.fetchImages();
		});
	},
	watch: {
		selectedFolders: {
			handler(value) {
				const folderId = value[value.length - 1];
				this.fetchFolders(folderId);
				this.fetchImages(folderId);
			},
			deep: true
		}
	},
	methods: {
		async fetchFolders(folderId?: string) {
			const response = await axios.get('/api/media/folder/list/' + (folderId ?? ''));
			if(response.status === 200) {
				this.folders = response.data.items;
			}
		},
		async fetchImages(folderId?: string) {
			const response = await axios.get('/api/media/file/list/' + (folderId ?? ''));
			if(response.status === 200) {
				this.images = response.data.items;
			}
		},
		openFolder(folderId: string) {
			this.selectedFolders.push(folderId);
		},
		backFolder() {
			this.selectedFolders.pop();
		},
		selectImage(image: MediaLibraryModalImageInterface) {
			this.emitter.emit('MediaLibraryModal_select_' + this.passedData.imageUploadId, {
				id: image.id,
				name: image.name,
				original: image.original,
				webp: image.webp
			});
			this.emitter.emit('onModalClose_media-library');
		},
		onModalPassedData(passedData: object) {
			this.passedData = passedData;
		}
	}
});
</script>
